<template>
  <div class="wrapper">
    <h1><span class="logo">CARTE CADEAU</span> Import des codes MID</h1>
    <div class="onglets">
      <ul>
        <li class="active">
          <h2>
            <i class="far fa-credit-card"></i> MID Importés {{ total_users }}
          </h2>
        </li>
        <li><!-- <h2>Import de points</h2> --></li>
      </ul>
      <div class="contenu">
        <div v-if="!analyse" class="options">
          <div>
            <h4>
              <span>1.</span> Importer votre fichier au format .xls ou .xlsx
            </h4>
          </div>
          <div>
            <h4>
              <div class="upload-btn-wrapper">
                <button class="upload-btn">
                  <i class="fas fa-cloud-upload-alt"></i> Importer un fichier
                  excel
                </button>
                <input
                  type="file"
                  @change="importExcel"
                  id="upload"
                  accept="text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                />
              </div>
              <span v-if="file_name" class="upload-btn-set">
                &nbsp; <img src="/Excel-Icon.png"/> {{ file_name
                }}<br />&nbsp;<br
              /></span>
              <div class="help">
                <i class="far fa-question-circle"></i> Intitulé obligatoire :
                MID, Siret
              </div>
              <div class="help">
                <i class="far fa-question-circle"></i> Intitulés annexes :
                RaisonSociale, Email, Nom, Prenom, Adresse, Adresse2, Ville,
                CodePostal, Pays
              </div>
            </h4>
          </div>
          <div v-if="client == 'mcb'">
            <h4><span>2.</span> Suppression automatique des doublons</h4>
          </div>
          <div v-if="client == 'mcb'">
            <h4>
              <input
                type="radio"
                id="oui"
                v-model="autoremove"
                name="type"
                value="oui"
              />&nbsp;<label for="oui">Oui</label>
              <input
                type="radio"
                id="non"
                v-model="autoremove"
                name="type"
                value="non"
              />&nbsp;<label for="non">Non</label>
            </h4>
          </div>
        </div>
        <div v-if="fileColumns.length > 0 && total_lines === 0">
          <div>
            <h2>Correspondence des colonnes</h2>
            <div class="preview">
              <table>
                <thead>
                  <tr>
                    <th scope="col">Champ</th>
                    <th scope="col">Colonne de votre fichier</th>
                    <th scope="col">Aperçu</th>
                    <th scope="col">Validité</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="rTableRow"
                    v-for="[field, fieldInfo] in Object.entries(fields)"
                    :key="field"
                  >
                    <td>{{ fieldInfo.label }}</td>
                    <td>
                      <select name="" id="" v-model="columnMapping[field]">
                        <option v-if="!fieldInfo.required" value="">
                          Ignorer ce champ
                        </option>
                        <option
                          v-for="(column, index) in fileColumns"
                          :key="index"
                          :value="column"
                        >
                          {{ column }}
                        </option>
                      </select>
                    </td>
                    <td>{{ excelData[0][columnMapping[field]] }}</td>
                    <td>
                      <span
                        v-if="
                          !fieldInfo.validation ||
                            fieldInfo.validation(
                              excelData[0][columnMapping[field]]
                            )
                        "
                        style="color: #4caf50"
                        >Valide</span
                      >
                      <span v-else style="color: #c94330">Invalide</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
          </div>
        </div>
        <div v-if="!analyse">
          <button @click="checkXSL">
            <i class="fas fa-search"></i>&nbsp;<span>Analyser</span>
          </button>
          &nbsp;
          <router-link
            tag="button"
            v-if="client == 'mcb'"
            class="blue"
            to="/logs"
            ><i class="fas fa-chart-bar"></i>&nbsp;<span>Logs</span>
          </router-link>
        </div>
        <div v-if="total_lines > 0">
          <div>
            <h3>
              Nombre total de MID dans votre fichier excel :
              <b>{{ total_lines }}</b>
            </h3>
          </div>
          <div v-if="total_users_add > 0">
            <h3>
              Nombre de MID <span v-if="!final">a</span> ajoutés :
              <b>{{ total_users_add }}</b>
            </h3>
          </div>
          <div v-if="total_users_update > 0">
            <h3>
              Nombre de MID <span v-if="!final">a mettre</span> à jours :
              <b>{{ total_users_update }}</b>
            </h3>
          </div>

          <div>
            <br />
            <div v-if="doublons.length > 0">
              <table>
                <caption>
                  Doublons détectés ({{
                    total_doublons
                  }}
                  lignes dont
                  {{
                    unique_doublons
                  }}
                  uniques )
                </caption>
                <thead>
                  <tr>
                    <th scope="col">Ligne</th>
                    <th scope="col">MID</th>
                    <!-- <th scope="col">Email</th> -->
                    <th scope="col">Siret</th>
                    <th scope="col">Adresse</th>
                    <th scope="col">Ville</th>
                    <th scope="col">CodePostal</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="rTableRow"
                    v-for="item in orderedUsers"
                    :key="item.Line"
                  >
                    <td data-label="login">{{ item.Line + 1 }}</td>
                    <td data-label="login">{{ item.MID }}</td>
                    <!-- <td data-label="email">{{ item.Email }}</td> -->
                    <td data-label="nom">{{ item.Siret }}</td>
                    <td data-label="prenom">{{ item.Adresse }}</td>
                    <td data-label="adresse">{{ item.Ville }}</td>
                    <td data-label="adresse">{{ item.CodePostal }}</td>
                    <td data-label="action">
                      <button class="suppr" @click="deleteDoublon(item.Line)">
                        Conserver
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
            </div>
            <div v-else>
              <h2>Prévisualisation de votre import :</h2>
              <div class="preview">
                <table>
                  <thead>
                    <tr>
                      <th scope="col">Ligne</th>
                      <th scope="col">MID</th>
                      <!-- <th scope="col">Email</th> -->
                      <th scope="col">RaisonSociale</th>
                      <th scope="col">Adresse</th>
                      <th scope="col">Ville</th>
                      <th scope="col">CodePostal</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="rTableRow"
                      v-for="item in orderedPreview"
                      :key="item.Line"
                    >
                      <td data-label="login">{{ item.Line + 1 }}</td>
                      <td data-label="login">{{ item.MID }}</td>
                      <!-- <td data-label="email">{{ item.Email }}</td> -->
                      <td data-label="nom">{{ item.RaisonSociale }}</td>
                      <td data-label="prenom">{{ item.Adresse }}</td>
                      <td data-label="adresse">{{ item.Ville }}</td>
                      <td data-label="adresse">{{ item.CodePostal }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
            </div>
            <button class="red" @click="reload" v-if="!final">
              <i class="fas fa-times"></i>&nbsp;<span>Annuler</span>
            </button>
            &nbsp;
            <button v-if="doublons.length == 0 && !final" @click="xlsToDB">
              <i class="fas fa-edit"></i>&nbsp;<span
                >Mettre à jour la base de données</span
              >
            </button>
            <button v-if="doublons.length > 0 && !final" @click="checkXSL">
              <i class="fas fa-search"></i>&nbsp;<span>Revérifier</span>
            </button>
            <button class="blue" @click="reload" v-if="final">
              <span>Uploader un nouveau fichier</span>
            </button>
            &nbsp;
          </div>
        </div>
        <div>
          <br />
          <collapse :selected="true">
            <div style="cursor: pointer" slot="collapse-header">
              <h2>
                <i class="far fa-question-circle"></i> Guide d'utilisation
              </h2>
            </div>
            <div class="guide" slot="collapse-body">
              Bienvenue sur le système d’import de codes MID (identifiants
              boutique). <br /><br />
              Pour garantir une acceptation maximale de
              <b>LA CARTE CADEAU</b> dans vos points de vente, il est important
              que chaque magasin soit identifié ici.<br /><br />
              Notre système vous permet : <br />
              &nbsp;&nbsp; - d’ajouter de nouveaux MID,<br />
              &nbsp;&nbsp; - d’actualiser les MID existants en cas d’évolution.

              <br /><br />
              <span style="color: red; font-weight: bold">IMPORTANT ! :</span
              ><br />
              <br />
              Il est important de respecter quelques règles simples :<br />
              <ul>
                <li>1. La colonne contenant les MID doit s’appeler MID</li>
                <li>
                  2. Vous devez avoir seulement une ligne d’en-tête dans votre
                  fichier
                </li>
                <li>
                  3. Les colonnes qui ne sont pas présentes dans le fichier
                  modèle ne seront pas prises en compte.
                </li>
              </ul>

              <br /><br />
              <a href="/ExempleEntetesImport.xlsx" target="_blank"
                >Vous trouverez ici un modèle en .xlsx type</a
              >
              <br /><br />
              <h2 style="color: green">Exemple correct :</h2>
              <img class="ok" src="/ok.png" />

              <br /><br />
              <h2 style="color: red">Exemples incorrects :</h2>
              <img class="nok" src="/nok.png" />
              <br /><br />
              <img class="nok" src="/nok2.png" />
            </div>
          </collapse>
        </div>
      </div>
    </div>
    <br />
    <div class="title">
      Client : {{ client }} ( Catégorie : {{ categorie }} , Pays : {{ pays }} )
    </div>
    <div></div>
  </div>
</template>

<script>
import xlsx from "xlsx";

const axios = require("axios").default;
const baseUrl =
  process.env.NODE_ENV == "production" || process.env.NODE_ENV == "staging"
    ? ""
    : "http://localhost:3000";
import Collapse from "vue-collapse";

export default {
  data() {
    return {
      json: undefined,
      autoremove: undefined,
      title: undefined,
      excelData: [],
      obj: [],
      total_users_add: false,
      total_users_update: false,
      level: undefined,
      levelpoints: undefined,
      type: undefined,
      total_lines: 0,
      analyse: false,
      doublons: [],
      final: false,
      file_name: undefined,
      total_users: undefined,
      choice: undefined,
      client: undefined,
      total_doublons: undefined,
      name: undefined,
      pays: undefined,
      categorie: undefined,
      fields: {
        MID: {
          label: "MID",
          required: true,
          validation: (value) =>
            (this.strictFormatter(value).match(/^[A-Za-z0-9*]+$/gm) || [])[0],
        },
        Siret: {
          label: "SIRET",
          required: true,
          validation: (value) =>
            (this.strictFormatter(value).match(
              /^(?:[0-9A-Z]{12,14})|(?:[0-9A-Z]{8})$/
            ) || [])[0],
        },
        RaisonSociale: { label: "Raison sociale" },
        Email: { label: "Email" },
        Nom: { label: "Nom" },
        Prenom: { label: "Prénom" },
        Adresse: { label: "Adresse" },
        Adresse2: { label: "Complément d'adresse" },
        CodePostal: { label: "Code postal" },
        Ville: { label: "Vile" },
        Pays: { label: "Pays" },
      },
      columnMapping: {},
    };
  },
  components: {
    Collapse,
  },
  async mounted() {
    // if(this.$route.query.publicToken) {
    //   alert(0)
    //   let json = {
    //     pulicToken: '149949185',
    //   };
    //   let { data } = await axios.post(baseUrl + "/get_transactions/", json);
    //   return false;
    /// }

    if (!this.$route.params._name) {
      this.$swal({
        icon: "error",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        confirmButtonColor: "#C94330",
        html: "Informations manquantes",
      });
    } else {
      try {
        let name = this.$route.params._name.toUpperCase();
        if (name == "MCB") name = "mcb";
        let user = await this.usersCheck(name);
        this.name = user.client;
        this.client = user.shortname;
        this.pays = user.pays;
        this.categorie = user.categorie;

        localStorage.setItem("client", this.client);
        await this.getTotalUsers();
      } catch (e) {
        console.log(e);
      }
    }
  },
  computed: {
    fileColumns() {
      return Object.keys(this.excelData.length ? this.excelData[0] : {});
    },
    mappedData() {
      return this.excelData.map((line) =>
        Object.entries(this.columnMapping).reduce(
          (mappedLine, [field, column]) => ({
            ...mappedLine,
            [field]: this.fields[field].validation
              ? this.fields[field].validation(line[column])
              : line[column],
          }),
          { Line: line.Line }
        )
      );
    },
    orderedPreview: function() {
      return this.mappedData.sort((a, b) => (a.Line > b.Line ? 1 : -1));
    },
    orderedUsers: function() {
      return this.doublons.sort((a, b) => (a.MID > b.MID ? 1 : -1)).reverse();
    },
  },
  methods: {
    strictFormatter: (value) =>
      value ? value.toString().replace(/ +/g, "") : "",
    usersCheck: async function(name) {
      let json = {
        client: name,
      };
      let { data } = await axios.post(baseUrl + "/get_user/", json);
      if (!data[0]) {
        this.$swal({
          icon: "error",
          showCancelButton: false,
          showConfirmButton: false,
          allowOutsideClick: false,
          confirmButtonColor: "#C94330",
          html: "Invalide User",
        });
      } else {
        return data[0];
      }
    },
    logsTo: function() {
      let json = {
        add: this.total_users_add,
        update: this.total_users_update,
        client: this.client,
      };
      axios.post(baseUrl + "/logs_action/", json).then((response) => {
        let result = response;
        resolve(result);
      });
    },
    noAccess: function() {
      this.$swal({
        icon: "error",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        confirmButtonColor: "#C94330",
        html: "Opération inconnue",
      });
    },
    getTotalUsers: async function() {
      let json = {
        client: this.client,
      };
      let tt_users = await axios.post(baseUrl + "/count_mids/", json);
      if (tt_users.data > 0) {
        this.total_users = "(" + tt_users.data + ")";
      }
      return;
    },
    reload() {
      document.location.reload(true);
    },
    checkAccount: function(datas) {
      let json = {
        mids: datas,
        client: this.client,
      };
      return new Promise((resolve) => {
        axios.post(baseUrl + "/check_mids/", json).then((response) => {
          let result = response;
          resolve(result);
        });
      });
    },
    saveAccount: async function(datas) {
      let json = {
        datas,
        client: this.client,
        categorie: this.categorie,
        pays: this.pays,
      };
      return new Promise((resolve) => {
        axios.post(baseUrl + "/save_mids/", json).then((response) => {
          const result = response;
          resolve(result);
        });
      });
    },
    checkXSL: async function() {
      this.$swal({
        allowOutsideClick: false,
        title: "Vérifications en cours",
        html: "Merci de bien vouloir patienter ...",
        timerProgressBar: true,
        onBeforeOpen: () => {
          this.$swal.showLoading();
        },
      });

      if (this.excelData.length < 1) {
        this.$swal({
          icon: "error",
          confirmButtonColor: "#C94330",
          text: "Merci de sélectionner un fichier excel",
        });
        return false;
      }

      const invalidLines = this.mappedData.reduce(
        (invalidLines, line, index) => {
          const isInvalid = !Object.entries(line).reduce(
            (isValid, [field, value]) =>
              isValid &&
              (!this.fields[field] ||
                !this.fields[field].validation ||
                this.fields[field].validation(value)),
            true
          );

          console.log(line, isInvalid);

          return isInvalid ? [...invalidLines, index + 1] : invalidLines;
        },
        []
      );

      if (invalidLines.length) {
        this.$swal({
          icon: "error",
          html:
            "Les lignes " +
            invalidLines.join(", ") +
            " contiennent des données invalides.",
          showCancelButton: false,
          confirmButtonText: `Ok`,
          confirmButtonColor: "#C94330",
        });
        return false;
      }

      let empty = this.checkIfEmpty(this.mappedData);
      if (empty > 0) {
        if (empty == 1) empty = "une";
        this.$swal({
          icon: "error",
          html:
            "Désolé. Nous avons détecter " +
            empty +
            " ligne(s)<br />sans MID dans votre fichier",
          showCancelButton: false,
          confirmButtonText: `Ok`,
          confirmButtonColor: "#C94330",
        }).then((result) => {
          if (result.isConfirmed) {
            document.location.reload(true);
          }
        });
        return false;
      }

      this.total_lines = this.excelData.length;
      this.analyse = true;

      if (this.client != "mcb") {
        this.autoremove = "non";
      }

      if (this.autoremove == "non") {
        this.doublons = [];
        let duplicate = this.checkDuplicate();
        if (duplicate.length > 0) {
          // Doublons détéctés
          this.doublons = duplicate;
          this.countDoublons();
          this.$swal({
            icon: "error",
            confirmButtonColor: "#C94330",
            text: "Nous avons détecté des doublons",
          });
          return false;
        }
      } else {
        this.excelData = this.getUnique(this.excelData, "MID");
        this.total_lines = this.excelData.length;
      }

      this.check_status();
      this.$swal.close();
    },
    xlsToDB: async function() {
      this.$swal({
        icon: "warning",
        text: "Confirmez la mise à jour de la base de données ?",
        showCancelButton: true,
        confirmButtonText: `Je confirme`,
        confirmButtonColor: "#28a745",
        cancelButtonText: `Annuler`,
        cancelButtonColor: "#C94330",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal({
            allowOutsideClick: false,
            title: "Mise à jour en cours",
            html: "Merci de bien vouloir patienter ...",
            timerProgressBar: true,
            onBeforeOpen: () => {
              this.$swal.showLoading();
            },
          });

          try {
            let promises = [];
            promises.push(this.saveAccount(this.mappedData));

            Promise.all(promises)
              .then(async (results) => {
                console.log(results);
                this.final = true;
                this.logsTo();
                this.$swal({
                  icon: "success",
                  html: "Base de données mise à jour avec succès",
                  showCancelButton: false,
                  confirmButtonText: `Ok`,
                  confirmButtonColor: "#C94330",
                }).then((result) => {
                  if (result.isConfirmed) {
                    document.location.reload(true);
                  }
                });
              })
              .catch((e) => {
                console.log(e);
                this.$swal({
                  icon: "error",
                  confirmButtonColor: "#C94330",
                  text: "Erreur survenue pendant le process",
                });
              });
          } catch (e) {
            console.log(e);
            this.$swal({
              icon: "error",
              confirmButtonColor: "#C94330",
              text: "Erreur survenue pendant le process",
            });
          }
        }
      });
    },
    async importExcel(e) {
      this.$swal({
        allowOutsideClick: false,
        title: "Upload en cours",
        html: "Merci de bien vouloir patienter ...",
        timerProgressBar: true,
        onBeforeOpen: () => {
          this.$swal.showLoading();
        },
      });

      const files = e.target.files;

      if (!files.length) {
        this.$swal.close();
        return;
      } else if (!/\.(xls|xlsx|csv)$/.test(files[0].name.toLowerCase())) {
        this.$swal({
          icon: "error",
          confirmButtonColor: "#C94330",
          text: "Votre fichier doit être au format .xls, .xlsx ou csv",
        });
        return false;
      }

      this.file_name = files[0].name;

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;

          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);
          ws.forEach((object, i) => (object.Line = i + 1));

          this.excelData = ws;
          this.buildDefaultMapping();
          this.$swal.close();
        } catch (e) {
          console.log(e);
          // this.$swal({ icon: 'error',confirmButtonColor: '#C94330', text: 'Erreur de lecture !' })
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },
    checkIfEmpty: function(original) {
      let i = 0;
      Object.keys(original).forEach(function(key) {
        if (original[key].MID === undefined) {
          i++;
        }
      });
      return i;
    },
    countDoublons() {
      this.total_doublons = this.doublons.length;
      let unique = this.getUnique(this.doublons, "MID");
      this.unique_doublons = unique.length;
      this.total_lines = this.excelData.length;
    },
    checkDuplicate() {
      let list = this.excelData;
      let countList = list.reduce(function(p, c) {
        p[c.MID] = (p[c.MID] || 0) + 1;
        return p;
      }, {});

      let result = list.filter(function(obj) {
        return countList[obj.MID] > 1;
      });
      this.check_status();
      return result;
    },
    getUnique(arr, comp) {
      const unique = arr
        .map((e) => e[comp])
        .map((e, i, final) => final.indexOf(e) === i && i)
        .filter((e) => arr[e])
        .map((e) => arr[e]);
      return unique;
    },
    check_status: function() {
      let unique_login = this.excelData.map((u) => u.MID);

      try {
        let promises = [];
        promises.push(this.checkAccount(unique_login));

        Promise.all(promises)
          .then(async (results) => {
            this.total_users_add = results[0].data.new;
            this.total_users_update = results[0].data.update;
          })
          .catch((e) => {
            console.log(e);
            this.$swal({
              icon: "error",
              confirmButtonColor: "#C94330",
              text: "Erreur survenue pendant le process",
            });
          });
      } catch (e) {
        console.log(e);
        this.$swal({
          icon: "error",
          confirmButtonColor: "#C94330",
          text: "Erreur survenue pendant le process",
        });
      }
    },
    deleteDoublon(line) {
      this.$swal({
        icon: "warning",
        text: "Conserver ce MID ?",
        showCancelButton: true,
        confirmButtonText: `Je confirme`,
        confirmButtonColor: "#28a745",
        cancelButtonText: `Annuler`,
        cancelButtonColor: "#C94330",
      }).then((result) => {
        if (result.isConfirmed) {
          let keep_user = this.doublons.filter((el) => el.Line === line);
          let all_users = this.doublons.filter(
            (el) => el.MID === keep_user[0].MID && el.Line !== line
          );

          for (var i = 0; i < all_users.length; i++) {
            this.doublons = this.doublons.filter(
              (el) => el.MID !== all_users[i].MID
            );
            this.excelData = this.excelData.filter(
              (el) => el.Line !== all_users[i].Line
            );
          }

          this.countDoublons();
          this.checkDuplicate();
          this.$swal({
            position: "top-end",
            icon: "success",
            title: "MID conservé !",
            showConfirmButton: false,
            timer: 1500,
          });
        } else if (result.isDenied) {
        }
      });
    },
    buildDefaultMapping() {
      this.columnMapping = Object.keys(this.fields).reduce(
        (mapping, field, index) => ({
          ...mapping,
          [field]:
            this.fileColumns.length > index ? this.fileColumns[index] : "",
        }),
        {}
      );
    },
  },
};
</script>
